import React, { FC } from 'react';
import { HeadFC, PageProps, graphql } from 'gatsby';

import Home from '../views/Home';
import SEO from '../components/Head';
import LayoutRaw from '../components/Layout/Layout';

interface ContextType {
  locale: string;
  name: string;
}

const LinkPage: FC<
  PageProps<Queries.OnramperQueryQuery, ContextType>
> = props => {
  const { pageContext, data } = props;

  return (
    <LayoutRaw>
      <Home data={data} locale={pageContext.locale} provider="link" />
    </LayoutRaw>
  );
};

export const Head: HeadFC<Queries.OnramperQueryQuery, ContextType> = ({
  data: { file },
  pageContext,
  location,
}) => {
  return (
    <SEO
      meta={file?.childJson?.meta || null}
      pathname={location.pathname}
      locale={pageContext.locale}
    />
  );
};

export const query = graphql`
  query OnramperQuery($name: String!) {
    file(name: { eq: $name }, relativePath: { glob: "**/link/**" }) {
      childJson {
        ...Meta
        ...SeoNavbar
        ...SeoHeaderHome
        ...SeoWhyHome
        ...SeoGuideHome
        ...SeoBitcoinPriceSection
        ...SeoReadytoGetStarted
        ...SeoFooter
      }
    }
  }
`;

export default LinkPage;
